import React from "react";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { IconWrapper } from "./IconWrapper";

interface SwitchProps {
  id: string;
  header: string;
  show: boolean;
  switchAction: (id: string) => void;
  overlayId?: string;
  overlayToggle?: (id: string) => void;
  divStyle?: string;
  labelStyle?: string;
}

export const Switch: React.FC<SwitchProps> = ({
  id,
  header,
  switchAction,
  show,
  overlayId,
  overlayToggle,
  divStyle,
  labelStyle,
}) => {
  const toggleActivation = show ? "active" : "";

  const mouseHoverTrigger = (e: any) => {
    overlayToggle(overlayId);
  };

  const labelStyles = labelStyle
    ? labelStyle
    : "uppercase font-bold text-brand-dark_blue";
  const divStyles = divStyle ? divStyle : "px-5 m-2";

  return overlayId ? (
    <div className={divStyle}>
      <div className='flex justify-evenly'>
        <div>
          <span className={labelStyle}>{header}</span>
        </div>
        <IconWrapper styles={"self-center ml-auto"}>
          <IoIosHelpCircleOutline
            onMouseEnter={(e) => mouseHoverTrigger(e)}
            onMouseLeave={(e) => mouseHoverTrigger(e)}
            size={30}
          />
        </IconWrapper>
      </div>
      <div className={`toggle-component ${toggleActivation}`}>
        <div className='toggle-button' onClick={() => switchAction(id)} />
      </div>
    </div>
  ) : (
    <div className={divStyles}>
      <span className={labelStyles}>{header}</span>
      <div className={`toggle-component ${toggleActivation}`}>
        <div className='toggle-button' onClick={() => switchAction(id)} />
      </div>
    </div>
  );
};
